<template>
    <v-img :src="calculateImage" contain :height="imageHeight" />
</template>

<script>
export default {
    name: 'HumanImage',
    props: {
        ageOnMonth: {type: Number, required: true, default: () => 0},
        gender: {type: Boolean, required: true, default: () => false},
        activeName: {type: String, required: false, default: () => null},
        dialogSomaticName: {type: String, required: false, default: () => null},
        switchBeforeOrAfterOne: {type: Boolean, required: false, default: () => false},
        heightOffset: {type: Number, required: false, default: () => 0}
    },
    data: () => ({
        imageHeight: 600
    }),
    computed: {
        calculateImage() {
            let nameSystem = '';

            // Назначаем значение переменной с названием для пути к папке с файлами этой системы
            if(this.activeName === 'Дыхательная система' || this.dialogSomaticName === 'Дыхательная система') nameSystem = 'DS'
            if(this.activeName === 'Пищеварительная система' || this.dialogSomaticName === 'Пищеварительная система') nameSystem = 'PS'
            if(this.activeName === 'Мочевая система' || this.dialogSomaticName === 'Мочевая система') nameSystem = 'MS'
            if(this.activeName === 'Костно-мышечная система' || this.dialogSomaticName === 'Костно-мышечная система') nameSystem = 'KMS'
            if(this.activeName === 'Сердечно-сосудистая система' || this.dialogSomaticName === 'Сердечно-сосудистая система') nameSystem = 'SSS'
            if(this.activeName === 'Нервная система' || this.dialogSomaticName === 'Нервная система') nameSystem = 'NS'
            if(this.activeName === 'Лимфатическая система' || this.dialogSomaticName === 'Лимфатическая система') nameSystem = 'LS'
            if(this.activeName === 'Покровная система' || this.dialogSomaticName === 'Покровная система') nameSystem = 'PSSS'
            if(this.activeName === 'Сенсорная система' || this.dialogSomaticName === 'Сенсорная система') nameSystem = 'PSSS'
            if(this.activeName === 'Эндокринная система' || this.dialogSomaticName === 'Эндокринная система') nameSystem = 'ES'
            if(this.activeName === 'Органы кроветворения и иммунной системы' || this.dialogSomaticName === 'Органы кроветворения и иммунной системы') nameSystem = 'OKIS'
            if(this.activeName === 'Показатели физического развития' || this.dialogSomaticName === 'Показатели физического развития') nameSystem = 'Default'
            if(this.activeName === 'Лабораторные исследования' || this.dialogSomaticName === 'Лабораторные исследования') nameSystem = 'Default'
            if(this.activeName === 'Репродуктивная система' || this.dialogSomaticName === 'Репродуктивная система') nameSystem = 'RS'

            // Психические функции
            if(!this.switchBeforeOrAfterOne && this.activeName === 'Система психических функций' || this.dialogSomaticName === 'Система психических функций') nameSystem = 'PSSS'
            if(this.switchBeforeOrAfterOne && this.activeName === 'Система психических функций' || this.dialogSomaticName === 'Система психических функций') nameSystem = 'Psyhic'


            // console.log('this.switchBeforeOrAfterOne', this.switchBeforeOrAfterOne);

            // Если выбран флаг до 1 года
            if(this.switchBeforeOrAfterOne) {
                // временно сделаю заглушку
                // с 1 года до 2 лет
                if( (this.ageOnMonth == 0 || this.ageOnMonth < 4) && !this.gender) return require(`../../assets/humanSystems/${nameSystem}/${nameSystem}-M-0.svg`)
                if( (this.ageOnMonth == 0 || this.ageOnMonth < 4) && this.gender) return require(`../../assets/humanSystems/${nameSystem}/${nameSystem}-J-0.svg`)

                // с 3 лет до 5 лет
                if( (this.ageOnMonth >= 4 && this.ageOnMonth < 8) && !this.gender) return require(`../../assets/humanSystems/${nameSystem}/${nameSystem}-M-4.svg`)
                if( (this.ageOnMonth >= 4 && this.ageOnMonth < 8) && this.gender) return require(`../../assets/humanSystems/${nameSystem}/${nameSystem}-J-4.svg`)

                // с 6 лет до 9 лет
                if( (this.ageOnMonth >= 8 && this.ageOnMonth <= 12) && !this.gender) return require(`../../assets/humanSystems/${nameSystem}/${nameSystem}-M-8.svg`)
                if( (this.ageOnMonth >= 8 && this.ageOnMonth <= 12) && this.gender) return require(`../../assets/humanSystems/${nameSystem}/${nameSystem}-J-8.svg`)

            } else {
                // с 1 года до 2 лет
                console.log(nameSystem);
                if( (this.ageOnMonth == 0 || this.ageOnMonth < 3) && !this.gender) return require(`../../assets/humanSystems/${nameSystem}/${nameSystem}-M-1.svg`)
                if( (this.ageOnMonth == 0 || this.ageOnMonth < 3) && this.gender) return require(`../../assets/humanSystems/${nameSystem}/${nameSystem}-J-1.svg`)

                // с 3 лет до 5 лет
                if( (this.ageOnMonth >= 3 && this.ageOnMonth < 6) && !this.gender) return require(`../../assets/humanSystems/${nameSystem}/${nameSystem}-M-3.svg`)
                if( (this.ageOnMonth >= 3 && this.ageOnMonth < 6) && this.gender) return require(`../../assets/humanSystems/${nameSystem}/${nameSystem}-J-3.svg`)

                // с 6 лет до 9 лет
                if( (this.ageOnMonth >= 6 && this.ageOnMonth < 10) && !this.gender) return require(`../../assets/humanSystems/${nameSystem}/${nameSystem}-M-6.svg`)
                if( (this.ageOnMonth >= 6 && this.ageOnMonth < 10) && this.gender) return require(`../../assets/humanSystems/${nameSystem}/${nameSystem}-J-6.svg`)

                // с 10 лет до 12 лет
                if( (this.ageOnMonth >= 10 && this.ageOnMonth < 13) && !this.gender) return require(`../../assets/humanSystems/${nameSystem}/${nameSystem}-M-10.svg`)
                if( (this.ageOnMonth >= 10 && this.ageOnMonth < 13) && this.gender) return require(`../../assets/humanSystems/${nameSystem}/${nameSystem}-J-10.svg`)

                // с 13 лет до 15 лет
                if( (this.ageOnMonth >= 13 && this.ageOnMonth < 16) && !this.gender) return require(`../../assets/humanSystems/${nameSystem}/${nameSystem}-M-13.svg`)
                if( (this.ageOnMonth >= 13 && this.ageOnMonth < 16) && this.gender) return require(`../../assets/humanSystems/${nameSystem}/${nameSystem}-J-13.svg`)

                // с 16 лет до 17 лет
                if( (this.ageOnMonth >= 16 && this.ageOnMonth < 18) && !this.gender) return require(`../../assets/humanSystems/${nameSystem}/${nameSystem}-M-16.svg`)
                if( (this.ageOnMonth >= 16 && this.ageOnMonth < 18) && this.gender) return require(`../../assets/humanSystems/${nameSystem}/${nameSystem}-J-16.svg`)

                // с 16 лет до 17 лет
                if(this.ageOnMonth >= 18 && !this.gender) return require(`../../assets/humanSystems/${nameSystem}/${nameSystem}-M-18.svg`)
                if(this.ageOnMonth >= 18 && this.gender) return require(`../../assets/humanSystems/${nameSystem}/${nameSystem}-J-18.svg`)
            }

            return ''
        }
    },
    created() {

        if (document.documentElement.clientWidth <= 960) {
            this.imageHeight = window.innerHeight - this.heightOffset;
        }
    }
}
</script>